import { Component, OnInit } from "@angular/core";
import { RuleDao } from "../core/model/rule-dto";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { RuleService } from "../core/service/rule.service";
import { EditRuleEngineComponent } from "./edit-rule-engine/edit-rule-engine.component";
import { AddRuleEngineComponent } from "./add-rule-engine/add-rule-engine.component";

@Component({
  selector: "app-rule-engine",
  templateUrl: "./rule-engine.component.html",
  styleUrls: ["./rule-engine.component.scss"],
})
export class RuleEngineComponent implements OnInit {
  rules: RuleDao[];
  ruleNamespace: String = "REPARTITEUR_FILTRE";

  constructor(
    private modalService: NgbModal,
    private _ruleService: RuleService
  ) {}

  ngOnInit() {
    this.getRulesByNamespace(this.ruleNamespace);
  }

  getRulesByNamespace(ruleNamespace) {
    this._ruleService.getRulesByNamespace(ruleNamespace).subscribe(
      (data) => {
        this.rules = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(rule: RuleDao): void {
    const modalRef = this.modalService.open(EditRuleEngineComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.rule = rule;

    modalRef.result.then(
      (updated: RuleDao) => {
        if (updated && this.rules) {
          const index = this.rules.findIndex(
            (r) => r.ruleId === updated.ruleId
          );
          if (index !== -1) {
            this.rules[index] = updated;
            this.rules = [...this.rules];
            return;
          }
        }
        this.getRulesByNamespace(this.ruleNamespace);
      },
      (reason) => {}
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddRuleEngineComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });

    modalRef.result.then(
      (data) => {
        this.getRulesByNamespace(this.ruleNamespace);
      },
      (reason) => {}
    );
  }
}
